import type { StrategyFinderResult } from './strategy-finder-result.type.ts';
export interface StrategyFinderResultExtension extends StrategyFinderResult {}
export class StrategyFinderResultExtension {
  // ── Computed Properties ──
  get isComplete() {
    return !!(this.chosenPlan && this.currentPlan && this.recommendedPlan);
  }
}

const Registration = {
  kind: 'object',
  name: 'strategy-finder-result',
  features: StrategyFinderResultExtension,
};
export default Registration;
